const routeMap = {
  namespaced: true,
  state: {
		station_info: { name: '', lon: 0, lat: 0, seq: 0 }
  },
  getters: {
  },
  mutations: {
    MUT_STATION_INFO: (state, payload) => {
      state.station_info = payload;
    }
  },
  actions: {
  }
}

export default routeMap

